import { render, staticRenderFns } from "./callMethod.vue?vue&type=template&id=43a4810c&scoped=true"
import script from "./callMethod.vue?vue&type=script&lang=js"
export * from "./callMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a4810c",
  null
  
)

export default component.exports